/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.security.educator-growth-administrators'},
});

const EducatorGrowthAdministratorsItem = () => (
  <RouteLinkItem
    route="midas/settings/security/educator-growth-admin"
    title={messages.title}
  />
);

export default EducatorGrowthAdministratorsItem;
